import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=auth
  const [club, setClub] = useState(null);
  const [sportMeta, setSportMeta] = useState(null);

  const loadClub = useCallback(async () => {
    try {
      const { data } = await api.get("/clubs/me");
      setClub(data);
      try {
        const meta = await api.get(`/clubs/me/sport-config`);
        setSportMeta(meta.data);
      } catch (_) {
        try { const m = await api.get(`/meta/sport/${data.sport}`); setSportMeta(m.data); } catch (__) {}
      }
      return data;
    } catch (_) {
      setClub(null);
      setSportMeta(null);
      return null;
    }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadClub();
      return data;
    } catch (_) {
      setUser(null);
      setClub(null);
      return null;
    }
  }, [loadClub]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setUser(undefined);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("cs_token");
    setUser(null);
    setClub(null);
    setSportMeta(null);
  };

  const isPremium = user?.role === "admin" || (!!club && ["pro", "club"].includes(club.plan) && !!club.subscription_active);

  return (
    <AuthContext.Provider value={{ user, setUser, club, setClub, sportMeta, loadClub, refresh, logout, isPremium }}>
      {children}
    </AuthContext.Provider>
  );
}
